import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    socialresponsibilityList: [],
    socialresponsibility: null,
    links: null,
    meta: null,
    filter: {
      tab: '',
      keyword: '',
      status: '',
    },
    srTypeOptions: [
      { value: 'quality', text: 'Commitment to Quality' },
      { value: 'env', text: 'Environmental Promise' },
      { value: 'rohs', text: 'Taiwan RoHS' },
    ],
  },
  mutations: {
    CLEAR_ALL(state) {
      state.socialresponsibilityList = [];
      state.socialresponsibility = null;
    },
    SET_SOCIALRESPONSIBILITYLIST(state, data) {
      state.socialresponsibilityList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SOCIALRESPONSIBILITY(state, data) {
      state.socialresponsibility = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },
  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setSocialresponsibility({ commit }, data) {
      commit('SET_SOCIALRESPONSIBILITY', data);
    },

    find({ commit, state }) {
      let url = `/social-resp?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('SocialResponsibility'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SOCIALRESPONSIBILITYLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/social-resp/${id}`)
        .then((response) => response.body)
        .then(typeAs('SocialResponsibility'))
        .then((item) => {
          commit('SET_SOCIALRESPONSIBILITY', item);
        });
    },

    destroy(_, id) {
      return http(`/social-resp/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/social-resp/${id}`, { method: 'PUT', data })
        : http('/social-resp', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/social-resp/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
  },
};
